export default __webpack_public_path__ + "static/media/Ameena-with-books-and-blue-background.8f32c34d.svg";